export default __webpack_public_path__ + "static/media/CrptoTiles.cd4228e9.svg";